<template>
    <v-no-content v-if="isPermissionDenied">
        <span slot="title">Camera is not authorized</span>
        <span slot="description">This feature requires a camera to work with, please enable the permissions in your browser configuration.</span>
    </v-no-content>
    <v-no-content v-else-if="!isCameraAvailable">
        <span slot="title">Camera not found</span>
        <span slot="description">This feature requires a camera to work with. No camera device was found or is not supported.</span>
    </v-no-content>
    <div v-else>
        <v-inline-loader class="camera-device-is-loading" v-if="isLoading"/>
        <div class="camera-wrapper" v-show="!isLoading">
            <div class="camera-frame-overlay"></div>
            <div class="stack-s">
                <video ref="previewer" class="camera-device-previewer"></video>
            </div>
            <p>Try to position your ID card within the red and white bordered rectangle.</p>
        </div>
    </div>
</template>

<script>
    import Camera from '@/common/camera';
    import vNoContent from './v-no-content';
    import vInlineLoader from '@/components/v-inline-loader';
    import vLoader from './v-loader';

    export default {
        name: 'v-camera-device',
        components: {
            vLoader,
            vNoContent,
            vInlineLoader,
        },
        data() {
            return {
                camera: null,
                isCameraAvailable: Camera.isAvailable,
                isPermissionDenied: false,
                isLoading: true,
            };
        },
        methods: {
            submit() {
                const picture = this.camera.capture();
                this.$emit('submit', picture);
                this.camera.pause();
                return picture;
            },
            async loadCamera() {
                this.isLoading = true;
                this.camera = new Camera(this.$refs.previewer);
                try {
                    await this.camera.load();
                } catch (error) {
                    // TODO handle other errors
                    this.isCameraAvailable = false;
                    if ((error.contains && error.contains('Permission denied')) || (error.name === 'NotAllowedError')) {
                        this.isPermissionDenied = true;
                    }
                } finally {
                    this.isLoading = false;
                }
            },
        },
        mounted() {
            if (this.isCameraAvailable) {
                this.loadCamera();
            }
        },
    };
</script>
<style type="text/css" scoped>
    .camera-wrapper {
        position: relative;
    }
    .camera-frame-overlay {
        position: absolute;
        top: 50px;
        bottom: 80px;
        left: 50px;
        right: 50px;
        border: 2px solid red;
        box-shadow: inset 0 0 0 2px #ffffff;
    }
</style>
